import PropTypes from 'prop-types';
import React from 'react';

import AudioRecordingVisualizer from './AudioRecordingVisualizer';
import RecordingStatusVisualizer from './RecordingStatusVisualizer';
import StaticAudioVisualizer from './StaticAudioVisualizer';
import { isIOS13 } from '../../utils/browserUtils';

const RecordingVisualizer = ({
    onFailure,
    visualizerOptions,
    isVisualizerActive,
    hasStaticVisualizer,
    hasRecordingStatusBox,
    isExternalURLSourcePresent,
}) => {
    const options = {
        barWidth: 5,
        barHeight: 5,
        barGap: 10,
        barRadius: 5,
        cursorWidth: 0,
        height: isExternalURLSourcePresent ? 18 : 40,
        waveColor: isExternalURLSourcePresent ? '#6d8581' : '#4bb699',
    };
    const isStaticVisulizer = hasStaticVisualizer || isIOS13();
    const isVisualizerForArTro =
        !isStaticVisulizer && isExternalURLSourcePresent && isVisualizerActive;
    return (
        <div aria-hidden="true" className="audio-visualizer-container">
            {/* isIOS13 condition is added instead because dynamic visualizer breaks on iOS devices with recording */
            isStaticVisulizer && <StaticAudioVisualizer />}
            {/* It's another condition for AR TRO, improtant to NOT render this element when recording is not started,
                because autoplay of WaveSurfer.js is broke after page reload.
                */
            isVisualizerForArTro && (
                <AudioRecordingVisualizer
                    options={{ ...options, ...visualizerOptions }}
                    onFailure={onFailure}
                />
            )}
            {!isExternalURLSourcePresent && !isStaticVisulizer && (
                <AudioRecordingVisualizer
                    options={{ ...options, ...visualizerOptions }}
                    onFailure={onFailure}
                />
            )}
            {hasRecordingStatusBox && <RecordingStatusVisualizer recording={isVisualizerActive} />}
        </div>
    );
};

RecordingVisualizer.propTypes = {
    onFailure: PropTypes.func,
    visualizerOptions: PropTypes.object,
    isVisualizerActive: PropTypes.bool,
    hasStaticVisualizer: PropTypes.bool,
    hasRecordingStatusBox: PropTypes.bool,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
};

RecordingVisualizer.defaultProps = {
    onFailure: () => {},
    visualizerOptions: {},
    isVisualizerActive: false,
    hasStaticVisualizer: false,
    hasRecordingStatusBox: false,
};

export default RecordingVisualizer;
